module.exports = __webpack_public_path__ + "img/id4.69e8e0f7.png";